var Vector = require("./vector");

const TAU = Math.PI * 2;

var extend = require("extend");

function ring(graph, visited, center, minArc, maxArc, depth)
{
    var nodes = graph.nodes;


    visited[center] = true;

    var centerNode = nodes[center];
    var i, angle, refs = centerNode.biref;


    var count = 0;
    for (i = 0; i < refs.length; i++)
    {
        if (!visited[refs[i]])
        {
            count++;
        }
    }

    if (!count)
    {
        return;
    }

    var arcStep = (maxArc - minArc) / count;
    //console.log("arcStep", arcStep);

    for (i = 0, angle = minArc; i < refs.length; i++, angle += arcStep)
    {
        var id = refs[i];

        if (!visited[id])
        {
            var node = nodes[id];

            var dist = (graph.options.separationLimit * depth * 2);
            node.x = Math.cos(angle) * dist;
            node.y = Math.sin(angle) * dist;
            node.depth = depth;

            ring(graph, visited, node.id, angle, angle + arcStep, depth + 1);
        }
    }
}

const DEFAULT_SIZE = 40;

var defaultOptions = {
    /**
     * Zero-force distance for the separating force
     */
    separationLimit : DEFAULT_SIZE * 2.5,
    /**
     * Zero-force distance for the pulling edge force
     */
    edgeLimit : DEFAULT_SIZE * 1.4,
    /**
     * Linear multiplier of the separation force
     */
    separationForceMultiplier: 0.75,
    /** How much velocity gets lost every frame to due friction? */
    friction: 0.16
};

function Graph(options)
{
    this.options = extend({}, defaultOptions, options);
    this.nodes = [];

    if (options.friction > 1)
    {
        throw new Error("Friction must be between 0 and 1");
    }

    this.prevTension = 1000;
}

Graph.prototype.growRandom = function(max)
{
    if (typeof max !== "number" && max <= 0)
    {
        throw new Error("Need max count > 0");
    }

    var nodes = this.nodes;

    this.newNode();

    for (var i = 0; i < max - 1; i++)
    {
        var idx = (Math.random() * nodes.length)|0;

        var n = this.newNode();
        nodes[idx].ref.push(n.id);
    }
};

Graph.prototype.newNode = function()
{
    var nodes = this.nodes;

    var n = {
        x: 0,
        y: 0,
        dx: 0,
        dy: 0,
        id: nodes.length,
        ref: []
    };

    nodes.push(n);

    return n;
};


Graph.prototype.ease = function()
{
    var nodes = this.nodes;

    var tension = 0;
    var tensionCount = 0;
    var force, i, n, d;

    var separationLimit = this.options.separationLimit;
    var edgeLimit = this.options.edgeLimit;
    var separationForceMultiplier = this.options.separationForceMultiplier;

    for (i = 0; i < nodes.length; i++)
    {
        n = nodes[i];
        for (var j = nodes.length - 1; j > i; j--)
        {

            var n2 = nodes[j];
            var v = new Vector(n.x, n.y);
            v.subtract(n2);

            d = v.len();

            if (d < separationLimit)
            {
                force = Math.sqrt(separationLimit - d) * separationForceMultiplier;

                v.norm(force);

                tension += force;
                tensionCount++;

                n.dx += v.x;
                n.dy += v.y;

                n2.dx -= v.x;
                n2.dy -= v.y;
            }
        }

        var refs = n.ref;
        for (j = 0; j < refs.length; j++)
        {
            n2 = nodes[refs[j]];

            v = new Vector(n.x, n.y);
            v.subtract(n2);

            d = v.len();

            if (d > edgeLimit)
            {
                force = Math.sqrt(d - edgeLimit);
                v.norm(force);

                tension += force;
                tensionCount++;

                n.dx -= v.x;
                n.dy -= v.y;

                n2.dx += v.x;
                n2.dy += v.y;
            }
        }
    }

    var frictionMultiplier = 1 - this.options.friction;

    for (i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];

        node.x += node.dx;
        node.y += node.dy;

        node.dx *= frictionMultiplier;
        node.dy *= frictionMultiplier;
    }

    var current = tension / tensionCount;
    var result = (current + this.prevTension) / 2;
    this.prevTension = current;
    return result;
};

/**
 * Calculates the distance that the graph with the given id has to all other nodes in the graph walking the edges in both
 * directions
 *
 * @param graph     graph
 * @param id        id
 * @param visited   recursive state: nodes visited
 * @param count     recursive state: current distance sum
 * @param depth     recursive state: current depth
 *
 * @returns current distance sum
 */
function distanceToAllOtherNodes(graph, id, visited, count, depth)
{
    if (!visited[id])
    {
        // if we haven't yet visited the node, count it
        count += depth;

        // and remember we were here
        visited[id] = true;


        // walk over all connected nodes
        var nodes = graph.nodes;
        var ref = nodes[id].biref;
        for (var i = 0; i < ref.length; i++)
        {
            var n2 = nodes[ref[i]];
            // and continue the walk, now every node counts one step more than we did
            count = distanceToAllOtherNodes(graph, n2.id, visited, count, depth + 1);
        }
    }

    return count;
}


Graph.prototype.arrange = function(center)
{
    var nodes = this.nodes;

    var i;

    for (i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];
        if (!node.biref)
        {
            node.biref = node.ref.slice();

            for (var j = 0; j < nodes.length; j++)
            {
                var n2 = nodes[j];

                for (var k = 0; k < n2.ref.length; k++)
                {
                    if (n2.ref[k] === node.id)
                    {
                        node.biref.push(n2.id);
                    }
                }
            }
        }
    }

    if (!center)
    {
        var min = Infinity;
        for (i = 0; i < nodes.length; i++)
        {
            node = nodes[i];
            var sum = distanceToAllOtherNodes(this, node.id, {}, 0, 0);

            //console.log("graph distance", num);

            if (sum < min)
            {
                center = node.id;
                min = sum;
            }
        }
        //console.log("min", num, center);
    }

    nodes[center].x = 0;
    nodes[center].y = 0;
    nodes[center].depth = 0;

    ring(this, {}, center, 0, TAU, 1);

    return center;
};


Graph.prototype.getNodes = function()
{
    return this.nodes;
};

Graph.prototype.clean = function()
{
    var cleaned = new Array(this.nodes.length);

    var nodes = this.nodes;
    for (var i = 0; i < nodes.length; i++)
    {
        var node = nodes[i];
        cleaned[i] = {
            x: node.x|0,
            y: node.y|0,
            ref: node.ref
        };
    }

    return cleaned;
};


module.exports = Graph;
